/**
 * @desc 根据sku编码列表获取sku详情列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.PlmSkuDetailInfoResponseDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/getSkuDetailListBySkuNoList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
